import { createFileRoute } from "@tanstack/react-router";
import { AccountDeletedPage } from "@/features/user-profile/AccountDeletedPage";

export const Route = createFileRoute("/account-deleted")({
	component: AccountDeletedPage,
});
